<script>

    import { toast } from 'bulma-toast'
    import { userStore, usersStore, modalStore } from '../stores'

    import UsersService from '../$services/users.service'

    import Form from '../$components/form.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import ButtonCancel from '../$components/button.cancel.svelte'
    import Button from '../$components/button.svelte'
    import SelectUser from '../$components/select.users.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'

    let loading = false
    let user = null
    let changeOwner = false

    async function updateUserOwner() {

        const data = {
            userId: $userStore._id,
            ownerId: user._id
        }

        loading = true
        const resp = await UsersService.updateUserOwner($userStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: 'Asesor actualizado', type: 'is-success'})

        userStore.set(resp.data)
        usersStore.replace(resp.data)
        modalStore.close()
        changeOwner = false
    }

    function deleteOwner() {
        user = {}
        updateUserOwner()
    }

</script>

{#if $userStore.owner && !changeOwner}
    <DetailsCard title="Asesor principal">
        <DetailsFields>
            <DetailsField label="Nombre" value={$userStore.owner.name || 'Sin información'} />
            <DetailsField label="Correo" value={$userStore.owner.email || 'Sin información'} mono />
        </DetailsFields>
        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <Button
                        on:click={deleteOwner}
                        text="Quitar asesor principal"
                        icon="trash"
                        color="primary"
                    />
                    <Button
                        on:click={() => changeOwner = true}
                        text="Cambiar asesor principal"
                        icon="edit"
                        color="light"
                    />
                </div>
            </div>
        </div>
    </DetailsCard>
{/if}

{#if changeOwner || !$userStore.owner}
    <DetailsCard title="Cambiar asesor principal">
        <Form on:submit={updateUserOwner} {loading}>
            <SelectUser bind:user={user} role="adviser" />
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <ButtonCancel on:click={() => changeOwner = false} />
                    <ButtonSave />
                </div>
            </div>
        </Form>
    </DetailsCard>
{/if}